// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.message.LeasingMessageWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeasingMessageWebApiHandler_getLastMessage,
  LeasingMessageWebApiHandler_getLastMessage_Path,
} from '@zg-rentals/ts-leasing-client';

import type { GetLastMessageWebApiResponseDto } from '@zg-rentals/ts-leasing-client';

interface GetLastMessageParams {
  leaseId: number;
}

export type LeasingMessageWebApiHandler_getLastMessage_Options = UseQueryOptions<
  GetLastMessageWebApiResponseDto,
  unknown,
  GetLastMessageWebApiResponseDto,
  Array<string | GetLastMessageParams>
>;

const LeasingMessageWebApiHandler_getLastMessage_GetKey = (getParams: GetLastMessageParams) => [
  LeasingMessageWebApiHandler_getLastMessage_Path,
  getParams,
];

/**
 * get most recent lease message
 */
export const useLeasingMessageWebApiHandler_getLastMessage = (
  getParams: GetLastMessageParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingMessageWebApiHandler_getLastMessage_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeasingMessageWebApiHandler_getLastMessage_GetKey(getParams),
    queryFn: () => LeasingMessageWebApiHandler_getLastMessage(getParams, httpClient),
  });
};
useLeasingMessageWebApiHandler_getLastMessage.getKey = LeasingMessageWebApiHandler_getLastMessage_GetKey;
